module.exports = __webpack_public_path__ + "static/media/19ESCAP8.f563d414.jpg";